import LoginResetContainer from './containers/LoginResetContainer';

export default LoginResetContainer;
